exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-dropdown-link[data-v-7c0cec6c] {\n  cursor: pointer;\n  color: #409EFF;\n}\n.el-icon-arrow-down[data-v-7c0cec6c] {\n  font-size: 12px;\n}\n", ""]);

// exports
